import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Theme } from '~/theme/theme'

export const useSellingEasySectionStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      stepIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '25px',
        position: 'relative',
        height: '25px',
        borderRadius: '50%',
        zIndex: 20
      },

      counter: {
        fontSize: 16,
        color: theme.palette.primary.contrastText
      },

      dashedLine: {
        color: '#617589',
        position: 'absolute',
        borderStyle: 'dashed',
        borderWidth: '1px',
        top: 20,
        left: 12.5
      },

      descriptionText: {
        maxWidth: 541
      }
    }),
  { name: 'Stepper' }
)
